/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 2.83209C9.22492 2.2969 10.5778 2 12 2C17.5228 2 22 6.47715 22 12C22 13.4222 21.7031 14.7751 21.1679 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 2L4.92893 4.92893M22 22L19.0711 19.0711M19.0711 19.0711C17.2614 20.8807 14.7614 22 12 22C10.8606 22 9.88354 21.8377 8.97627 21.5132C8.11879 21.2065 7.69003 21.0531 7.52552 21.0144C6.0076 20.6574 5.3779 21.6977 4.06965 21.9157C3.42708 22.0228 2.85534 21.4967 2.90866 20.8475C2.95529 20.2798 3.34789 19.7429 3.50454 19.1977C3.83022 18.0644 3.38829 17.2052 2.9214 16.1973C2.33015 14.921 2 13.499 2 12C2 9.23858 3.11929 6.73858 4.92893 4.92893M19.0711 19.0711L4.92893 4.92893"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 11.9998C2 13.4988 2.33015 14.9207 2.9214 16.1971C3.38829 17.205 3.83022 18.0642 3.50454 19.1975C3.34789 19.7427 2.95529 20.2796 2.90866 20.8472C2.85534 21.4965 3.42708 22.0225 4.06965 21.9155C5.3779 21.6975 6.0076 20.6572 7.52552 21.0142C7.69003 21.0529 8.11879 21.2062 8.97627 21.513C9.88354 21.8375 10.8606 21.9998 12 21.9998C14.7614 21.9998 17.2614 20.8805 19.0711 19.0708L4.92893 4.92871C3.11929 6.73835 2 9.23835 2 11.9998Z"
				fill="currentColor"
			/>
			<path
				d="M2 2L4.92893 4.92893M22 22L19.0711 19.0711M19.0711 19.0711C17.2614 20.8807 14.7614 22 12 22C10.8606 22 9.88354 21.8377 8.97627 21.5132C8.11879 21.2065 7.69003 21.0531 7.52552 21.0144C6.0076 20.6574 5.3779 21.6977 4.06965 21.9157C3.42708 22.0228 2.85534 21.4967 2.90866 20.8475C2.95529 20.2798 3.34789 19.7429 3.50454 19.1977C3.83022 18.0644 3.38829 17.2052 2.9214 16.1973C2.33015 14.921 2 13.499 2 12C2 9.23858 3.11929 6.73858 4.92893 4.92893M19.0711 19.0711L4.92893 4.92893M8 2.83209C9.22492 2.2969 10.5778 2 12 2C17.5228 2 22 6.47715 22 12C22 13.4222 21.7031 14.7751 21.1679 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.53033 1.46967C2.23744 1.17678 1.76256 1.17678 1.46967 1.46967C1.17678 1.76256 1.17678 2.23744 1.46967 2.53033L3.8867 4.94736C2.24497 6.83457 1.25 9.30168 1.25 12C1.25 13.6102 1.60482 15.1395 2.24087 16.5125L2.9214 16.1973L2.24087 16.5125L2.26416 16.5628C2.74237 17.5948 3.01547 18.1841 2.78372 18.9906C2.73848 19.148 2.66921 19.2981 2.57345 19.5055C2.54526 19.5665 2.51477 19.6325 2.48193 19.7052C2.35571 19.9844 2.19594 20.3628 2.16118 20.7861C2.06787 21.9222 3.06842 22.8429 4.1929 22.6555L4.06965 21.9157L4.19291 22.6555C4.82849 22.5496 5.37238 22.2688 5.77258 22.0621C5.87095 22.0113 5.96065 21.965 6.04089 21.9269C6.46591 21.7249 6.82155 21.6193 7.35382 21.7445C7.46428 21.7705 7.83036 21.8998 8.72366 22.2194L8.97627 21.5132L8.72367 22.2194C9.72211 22.5765 10.786 22.75 12 22.75C14.6983 22.75 17.1654 21.755 19.0526 20.1133L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L19.6014 18.5407L5.45926 4.3986L2.53033 1.46967ZM8.30028 3.51935C9.43229 3.02475 10.6831 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 13.3169 20.9752 14.5677 20.4806 15.6997C20.3148 16.0793 20.4881 16.5214 20.8676 16.6873C21.2472 16.8531 21.6893 16.6798 21.8552 16.3003C22.431 14.9824 22.75 13.5275 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C10.4725 1.25 9.01756 1.56904 7.69972 2.14482C7.32016 2.31066 7.1469 2.7528 7.31274 3.13237C7.47857 3.51193 7.92071 3.68519 8.30028 3.51935Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 2L19.0711 19.0711M22 22L19.0711 19.0711M19.0711 19.0711C17.2614 20.8807 14.7614 22 12 22C10.8606 22 9.88354 21.8377 8.97627 21.5132C8.11879 21.2065 7.69003 21.0531 7.52552 21.0144C6.0076 20.6574 5.3779 21.6977 4.06965 21.9157C3.42708 22.0228 2.85534 21.4967 2.90866 20.8475C2.95529 20.2798 3.34789 19.7429 3.50454 19.1977C3.83022 18.0644 3.38829 17.2052 2.9214 16.1973C2.33015 14.921 2 13.499 2 12C2 10.5778 2.2969 9.22492 2.83209 8M8 2.83209C9.22492 2.2969 10.5778 2 12 2C17.5228 2 22 6.47715 22 12C22 13.4222 21.7031 14.7751 21.1679 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 2L4.92893 4.92893M22 22L19.0711 19.0711M19.0711 19.0711C17.2614 20.8807 14.7614 22 12 22C10.8606 22 9.88354 21.8377 8.97627 21.5132C8.11879 21.2065 7.69003 21.0531 7.52552 21.0144C6.0076 20.6574 5.3779 21.6977 4.06965 21.9157C3.42708 22.0228 2.85534 21.4967 2.90866 20.8475C2.95529 20.2798 3.34789 19.7429 3.50454 19.1977C3.83022 18.0644 3.38829 17.2052 2.9214 16.1973C2.33015 14.921 2 13.499 2 12C2 9.23858 3.11929 6.73858 4.92893 4.92893M19.0711 19.0711L4.92893 4.92893M8 2.83209C9.22492 2.2969 10.5778 2 12 2C17.5228 2 22 6.47715 22 12C22 13.4222 21.7031 14.7751 21.1679 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C9.0704 1.25 6.41324 2.42288 4.47498 4.32299L19.677 19.525C21.5771 17.5868 22.75 14.9296 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				d="M2.53033 1.46967C2.23744 1.17678 1.76256 1.17678 1.46967 1.46967C1.17678 1.76256 1.17678 2.23744 1.46967 2.53033L3.8867 4.94736C2.24497 6.83457 1.25 9.30168 1.25 12C1.25 13.5772 1.60161 15.1329 2.26416 16.5628C2.74237 17.5948 3.01547 18.1841 2.78372 18.9906C2.73848 19.148 2.66921 19.2981 2.57345 19.5055C2.54526 19.5665 2.51477 19.6325 2.48193 19.7052C2.35571 19.9844 2.19594 20.3628 2.16118 20.7861C2.06787 21.9222 3.06842 22.8429 4.1929 22.6555C4.82848 22.5496 5.37238 22.2688 5.77258 22.0621C5.87095 22.0113 5.96065 21.965 6.04089 21.9269C6.46591 21.7249 6.82155 21.6193 7.35382 21.7445C7.46428 21.7705 7.83036 21.8998 8.72366 22.2194C9.72211 22.5765 10.786 22.75 12 22.75C14.6983 22.75 17.1654 21.755 19.0526 20.1133L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L2.53033 1.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
